<template>
  <el-dialog title="完善出行人信息"
             :visible.sync="visableSelectTraveller"
             :showSelectTraveller="showSelectTraveller"
             custom-class="select_traveller_dialog_style"
             @close="OnClose()">
    <!-- 出行人首页 -->
    <div v-if="selectTravellerIsVisabled">
      <!-- 添加 行程所需的出行人信息 按钮 -->
      <div id="add-traveller-button">
        <el-button size="mini"
                   type="primary"
                   @click="addTravellerDialog">添加出行人</el-button>
      </div>
      <!-- 选择出行人  列表 -->
      <div id="select-traveller-button">
        <el-table empty-text="暂未添加出行人"
                  :data="travellerData"
                  style="width: 100%"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           width="35"></el-table-column>
          <el-table-column width="150">
            <template slot-scope="scope">
              <div>
                {{ scope.row.name
                }}<span v-if="scope.row.name_pinyin">｜{{ scope.row.name_pinyin }}</span>{{ scope.row.name_pinyin }}
              </div>
              <div>电话：{{ scope.row.phone }}</div>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="cerdential">
              <div v-for="(item, id) of cerdential.row.credential_info"
                   :key="id">
                {{ item.credential }}:{{ item.credential_no }}
              </div>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column>
            <template slot-scope="operating">
              <div>
                <div>
                  <el-link icon="el-icon-edit"
                           @click="editTravellerInfo(operating.row.id)">编辑</el-link>
                </div>
                <el-tag v-show="!operating.row.is_complate"
                        size="mini">信息不全,需要补充</el-tag>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center; margin-top: 20px"
             v-if="multipleSelection.length != 0">
          <el-button size="mini"
                     type="primary"
                     @click="bandTravellersToBooking">绑定出行人</el-button>
        </div>
      </div>
    </div>

    <!--------------------------------- 添加出行人的表单 模版 ------------------------------->
    <div v-if="addFormIsVisabled">
      <!-- 信息填写模版 -->
      <el-form class="base_info_list_style"
               label-position="left"
               :model="formTravellerInfo">
        <!-- 基本信息 -->
        <el-form-item :label-width="title_width"
                      label="姓名:">
          <el-input style="width: 50%"
                    size="mini"
                    v-model="formTravellerInfo.name"></el-input>
        </el-form-item>
        <el-form-item :label-width="title_width"
                      v-show="showEnName"
                      label="拼音姓:">
          <el-input style="width: 90%"
                    size="mini"
                    v-model="formTravellerInfo.surname"></el-input>
        </el-form-item>
        <el-form-item :label-width="title_width"
                      v-show="showEnName"
                      label="拼音名:">
          <el-input style="width: 90%"
                    size="mini"
                    v-model="formTravellerInfo.given_name"></el-input>
        </el-form-item>
        <div style="margin-bottom: 20px"></div>
        <el-form-item :label-width="title_width"
                      v-show="showPhone"
                      label="手机号:">
          <el-input style="width: 90%"
                    size="mini"
                    v-model="formTravellerInfo.phone"></el-input>
        </el-form-item>
        <el-form-item :label-width="title_width"
                      v-show="showEmail"
                      label="电子邮箱:">
          <el-input style="width: 90%"
                    size="mini"
                    v-model="formTravellerInfo.email"></el-input>
        </el-form-item>
        <el-form-item :label-width="title_width"
                      v-show="showGender"
                      label="性别:">
          <el-radio-group size="mini"
                          v-model="formTravellerInfo.gender">
            <el-radio-button label="1">男</el-radio-button>
            <el-radio-button label="0">女</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label-width="title_width"
                      v-show="showBirthday"
                      label="出生日期:">
          <el-date-picker style="width: 90%"
                          size="mini"
                          v-model="formTravellerInfo.birthday"
                          type="date"
                          placeholder="选择出生日期"
                          format="yyyy 年 MM 月 dd 日"
                          value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label-width="100px"
                      v-show="showHeight"
                      label="身高（cm）:">
          <el-input style="width: 30%"
                    size="mini"
                    v-model.number="formTravellerInfo.height"></el-input>
        </el-form-item>
        <el-form-item label-width="100px"
                      v-show="showWeight"
                      label="体重（kg）:">
          <el-input style="width: 30%"
                    size="mini"
                    v-model.number="formTravellerInfo.weight"></el-input>
        </el-form-item>
        <el-form-item label-width="100px"
                      v-show="showShose"
                      label="鞋码:">
          <el-input style="width: 30%"
                    size="mini"
                    v-model.number="formTravellerInfo.shoes_size"></el-input>
        </el-form-item>
        <el-form-item label-width="100px"
                      v-show="showLocation"
                      label="所在地:">
          <el-input style="width: 40%"
                    size="mini"
                    v-model.number="formTravellerInfo.location"></el-input>
        </el-form-item>
        <el-form-item label-width="100px"
                      v-show="showBorthLocation"
                      label="出生地:">
          <el-input style="width: 40%"
                    size="mini"
                    v-model.number="formTravellerInfo.borth_location"></el-input>
        </el-form-item>

      </el-form>

      <!------------------------ 证件信息 更新出行人 -------------------------->
      <div v-show="showCredential"
           class="credential_card_style"
           v-for="(item, id) of formCredentialList"
           :key="id">
        <div style="text-align: center">{{ item.name }}</div>
        <div label-position="left"
             label-width="35%"
             v-for="(i, id) of item.select"
             :key="id"
             :model="i">
          {{ i.name }}:
          <el-input v-show="i.type == 'num'"
                    style="width: 90%"
                    size="mini"
                    v-model="i.value"></el-input>
          <el-input v-show="i.type == 'text'"
                    style="width: 90%"
                    size="mini"
                    v-model="i.value"></el-input>
          <el-date-picker v-show="i.type == 'date'"
                          size="mini"
                          style="width: 90%"
                          v-model="i.value"
                          type="date"
                          placeholder="选择有效期"
                          format="yyyy 年 MM 月 dd 日"
                          value-format="yyyy-MM-dd"></el-date-picker>
        </div>
      </div>

      <!-- 提交 -->
      <div class="submit-traveller-button">
        <el-button type="primary"
                   size="mini"
                   @click="backToSelectList">返回</el-button>
        <el-button v-show="submitTravellerButton"
                   type="primary"
                   size="mini"
                   @click="sbumitTraveller">增加</el-button>
        <el-button v-show="!submitTravellerButton"
                   type="primary"
                   size="mini"
                   @click="reviseTraveller">保存修改</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
// let select_width = document.getElementById("select-traveller-button").width;
export default {
  name: 'select-add-traveller',
  data() {
    return {
      loading: true,
      booking_no: 0,
      traveller_id: 0,
      sku_id: this.sku_id_prop,
      // 选择按钮 盒子
      selectTravellerIsVisabled: true,
      addFormIsVisabled: false,
      dialog_width: '100%',
      visableSelectTraveller: this.showSelectTraveller,
      // 保存 与修改 出行人按钮
      submitTravellerButton: true,
      // 同行人模版数据
      travellerData: this.traveller_data,
      formTravellerInfo: {}, // 表单出行人表单信息
      formCredentialList: [], // 证件相关信息
      //
      labelPosition: 'right',
      title_width: '20%', // 表单的标题宽度
      // 出行人信息填写模版
      travellerTemplate: [],
      // 选择的出行人
      multipleSelection: [],
    }
  },
  props: {
    showSelectTraveller: { type: Boolean, default: false },
    sku_id_prop: Number,
    traveller_data: Array,
    booking_no_prop: Number,
  },
  computed: {
    // 基本信息
    showName: function () {
      for (let i of this.travellerTemplate) {
        if (i.id == 31) {
          return true
        }
      }
    },
    showEnName: function () {
      for (let i of this.travellerTemplate) {
        if (i.id == 32) {
          return true
        }
      }
    },
    showPhone: function () {
      for (let i of this.travellerTemplate) {
        if (i.id == 35) {
          return true
        }
      }
    },
    showEmail: function () {
      for (let i of this.travellerTemplate) {
        if (i.id == 40) {
          return true
        }
      }
    },

    showLocation: function () {
      for (let i of this.travellerTemplate) {
        if (i.id == 41) {
          return true
        }
      }
    },
    showBorthLocation: function () {
      for (let i of this.travellerTemplate) {
        if (i.id == 30) {
          return true
        }
      }
    },

    // 证件信息
    showCredential: function () {
      // let travellerTemplate_list = []
      for (let i of this.travellerTemplate) {
        if (i.select) {
          return true
        }
      }
    },
    // 身高 、体重、 鞋码、出生日期、性别
    showGender: function () {
      for (let i of this.travellerTemplate) {
        if (i.id == 34) {
          return true
        }
      }
    },

    showBirthday: function () {
      for (let i of this.travellerTemplate) {
        if (i.id == 33) {
          return true
        }
      }
    },
    showHeight: function () {
      for (let i of this.travellerTemplate) {
        if (i.id == 37) {
          return true
        }
      }
    },
    showWeight: function () {
      for (let i of this.travellerTemplate) {
        if (i.id == 38) {
          return true
        }
      }
    },
    showShose: function () {
      for (let i of this.travellerTemplate) {
        if (i.id == 39) {
          return true
        }
      }
    },
  },

  watch: {
    showSelectTraveller: {
      handler(newValue, oldValue) {
        this.visableSelectTraveller = newValue
      },
    },
    traveller_data: {
      handler(newValue) {
        this.travellerData = newValue
      },
    },
  },

  methods: {
    OnClose() {
      this.$emit('update:showSelectTraveller', false)
      this.$emit('onClose', false)
      this.addFormIsVisabled = false
      this.selectTravellerIsVisabled = true
    },
    selectTraveller() {},
    // 绑定出行人信息给订单
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    bandTravellersToBooking() {
      // 获取所选出行人ID，组成数组
      let t_id_list = []

      this.multipleSelection.forEach((i, index) => {
        t_id_list.push(i.id)
      })
      let band_item = {
        t_id_list,
        b_id: this.booking_no,
      }
      this.$http.post('/booking/band_traveller', band_item).then((res) => {
        const { errno, errmsg } = res.data
        if (errno == '0') {
          this.$notify({
            title: '成功',
            message: errmsg,
            type: 'success',
          })
          this.visableSelectTraveller = false
          this.$emit('finishBand')
        } else {
          this.$notify({
            title: '注意',
            message: errmsg,
            type: 'warning',
          })
        }
      })
    },
    // 删除出行人信息
    // 列表中 编辑已有出行人信息
    editTravellerInfo(value) {
      // 发送请求，请求产品的 出行人所需信息模版
      this.submitTravellerButton = false
      this.traveller_id = value
      this.$http
        .get(`get_traveller_template?booking_id=${this.booking_no}`)
        .then((res) => {
          const { data, errno, errmsg } = res.data
          if (data.length > 1) {
            this.$notify({
              title: '警告',
              message: '页面过期，或套餐未绑定模版。',
              type: 'warning',
            })
          } else {
            let travellerTemplate = new Function('return' + data[0].template)()
            this.travellerTemplate = travellerTemplate
            // 补充 证件模版 和已有的信息。 使用的是 出行人ID  和 订单id 的接口
            this.$http
              .get(
                `/booking/get_traveller_information?traveller_id=${this.traveller_id}&booking_id=${this.booking_no}`
              )
              .then((res) => {
                const { data, errno, errmsg } = res.data
                if (errno == '0') {
                  this.formTravellerInfo = data
                  this.formCredentialList = data.credential
                  // 出行人id，通过出行人信息获取 已填写的信息添加到模版
                  this.addFormIsVisabled = true
                  this.selectTravellerIsVisabled = false
                } else {
                  this.$notify.error({
                    title: '错误',
                    message: errmsg,
                  })
                }
              })
          }
        })
    },

    // 添加出行人信息 对话框 button
    addTravellerDialog() {
      // 发送请求，请求产品的 出行人所需信息
      this.submitTravellerButton = true
      this.formTravellerInfo = {}
      this.formCredentialList = []
      this.$http
        .get(`/get_traveller_template?booking_id=${this.booking_no}`)
        .then((res) => {
          const { data, errno, errmsg } = res.data
          let travellerTemplate = new Function('return' + data[0].template)()
          for (let item of travellerTemplate) {
            if (item.select) {
              this.formCredentialList.push(item)
            }
          }
          this.travellerTemplate = travellerTemplate
        })
      this.selectTravellerIsVisabled = !this.selectTravellerIsVisabled
      this.addFormIsVisabled = !this.addFormIsVisabled
    },
    // 提交添加出行人
    sbumitTraveller() {
      this.formTravellerInfo.booking_no = this.booking_no
      this.formTravellerInfo.credential = this.formCredentialList
      this.$http
        .post('/booking/add_travellers', this.formTravellerInfo)
        .then((res) => {
          const { errno, errmsg } = res.data
          if (errno == '0') {
            this.getTravellerList()
            this.$notify({
              title: '保存成功',
              message: errmsg,
              type: 'success',
            })
            this.formTravellerInfo = {}
            this.addFormIsVisabled = false
          } else {
            this.$notify.error({
              title: '错误',
              message: errmsg,
            })
          }
        })
    },
    // 提交修改/更新出行人
    reviseTraveller() {
      this.formTravellerInfo.traveller_id = this.traveller_id
      this.formTravellerInfo.credential = this.formCredentialList
      this.$http
        .post('/booking/change_traveller_information', this.formTravellerInfo)
        .then((res) => {
          const { errno, errmsg } = res.data
          if (errno == '0') {
            this.getTravellerList()
            this.$notify({
              title: '更改成功',
              message: errmsg,
              type: 'success',
            })
            this.formTravellerInfo = {}
            this.addFormIsVisabled = false
          } else {
            this.$notify.error({
              title: '错误',
              message: errmsg,
            })
          }
        })
    },
    getTravellerList() {
      // 请求数据，更新到列表
      this.$http
        .get(`/booking/get_all_travellers?booking_id=${this.booking_no}`)
        .then((res) => {
          const { data, errno, errmsg } = res.data
          if (errno == '0') {
            this.travellerData = data
            this.selectTravellerIsVisabled = true
          } else {
            this.$notify.error({
              title: '错误',
              message: errmsg,
            })
          }
        })
    },
    backToSelectList() {
      this.selectTravellerIsVisabled = !this.selectTravellerIsVisabled
      this.addFormIsVisabled = !this.addFormIsVisabled
    },
  },
}
</script>

<style>
#select-traveller-button {
  display: inline;
  margin-right: 10px;
}
#add-traveller-button {
  display: block;
}

.traveller-info-item {
  height: 20%;
  width: 20%;
  background-color: bisque;
}
.submit-traveller-button {
  clear: both;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.credential_item_body {
  text-align: center;
  background-color: bisque;
}
.el-form-item.credential_item_body {
  margin-bottom: 0px;
}
.base_info_list_style {
  float: left;
  width: 50%;
  min-height: 300px;
  padding: 0 0 40px 15px;
}
.credential_card_style {
  margin-bottom: 20px;
  float: left;
  padding: 10px 0px 20px 20px;
  width: 40%;
  background-color: bisque;
}
</style>